/* eslint-disable react/display-name */
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
/*import { Container, Row, Col, Button } from 'reactstrap';*/
import { Button, Card, CardBody, CardHeader, Col, Container, Row, UncontrolledTooltip, NavLink } from 'reactstrap';

import ReactTable, { ReactTableDefaults } from 'react-table';
import 'react-table/react-table.css';

import HttpUtil from '../../Util/httpUtil';
import Config from '../../Util/config';

import PesquisaRapida from '../Common/PesquisaRapida';
import TooltippedCel from '../Common/TooltippedCel';
import Pagination from '../../Util/Pagination';

import { AlertasContext } from '../../Providers/Alertas';
import { BlockUiContext } from '../../Providers/BlockUi';

import EmpresasCadastro from '../Modais/EmpresasCadastro';

import './Empresas.scss';

// let numPag = localStorage.getItem('paginaTamanho') == null ? 20 : localStorage.getItem('paginaTamanho')

Object.assign(ReactTableDefaults, {
	pageSizeOptions: [10, 20, 25, 50, 100],
	// pageSizeOptions: [20, 50, 100, 1000],
	defaultPageSize: 10,
	minRows: 10,
	//maxRows: 30,
	nextText: 'Próxima',
	previousText: 'Anterior',
	noDataText: 'Nenhum resultado encontrado',
	pageText: 'Pág.',
	ofText: 'de',
	rowsText: 'linhas',
	selectAll: true
});

function Empresas() {
	const [dataOnUpdate, setDataOnUpdate] = useState(null);
	const [rawData, setRawData] = useState([]);
	const [showData, setShowData] = useState([]);
	const [strBusca, setStrBusca] = useState('');
	const [blFiltroAtivo, setBlFiltroAtivo] = useState(false);
	const [blShowPesquisaRapida, setBlShowPesquisaRapida] = useState(false);
	const [pageData, setDataPage] = useState('');

	let reactTable = React.createRef();
	let ModalCadastro = React.createRef();

	/* eslint-disable no-unused-vars */
	let onLoading;
	let showInfoMessage;
	let showSuccessMessage;
	let showWarningMessage;
	let showErrorMessage;
	/* eslint-enable no-unused-vars */

	useEffect(() => {
		handleReload();
		window.addEventListener('paginaTamanho', () => {
			console.log("Enxergou o localstorage de longe!");
		})
	}, []);

	const handleReload = () => {
		onLoading(true);
		HttpUtil.eco_GET(`${Config.urls.API_URL_BASE}Empresa/Buscar`)
			.then(response => {
				onLoading(false);
				const { data } = response;
				const rawData = data.map(original => ({ ...original, blSelected: false }));
				setDataOnUpdate(null);
				setRawData(rawData);
				setShowData(rawData);
			})
			.catch(() => {
				onLoading(false);
				showErrorMessage('Erro ao carregar dados');
				setDataOnUpdate(null);
				setRawData([]);
				setShowData([]);
			});
	};

	const handleDataUpdated = () => {
		setDataOnUpdate(null);
		ModalCadastro.current.closeModal();
		handleReload();
	};

	const handleDataCreated = () => handleReload();

	const handleEditar = row => {
		setDataOnUpdate({
			...showData[row.index],
			blCertificadoEmpresa: String(showData[row.index].certificado !== 'econet'),
		});
		ModalCadastro.current.openModal();
	};

	const onUpdatePesquisaRapida = (data, strBusca, blShow) => {
		setShowData(data);
		setStrBusca(strBusca);
		setBlShowPesquisaRapida(blShow);
	};

	const childPaginationValue = (page) => {
		setDataPage(page);
	}

	const textFilterMethod = (filter, row) =>
		row[filter.id] && row[filter.id].toLowerCase().indexOf(filter.value.toLowerCase()) > -1;

	const columns = [
		{
			Header: () => <div className="text-left">CNPJ</div>,
			accessor: 'cnpj',
			width: 160,
			filterMethod: (filter, row) => row[filter.id] && row[filter.id].toString().includes(filter.value),
			className: 'text-left',
			Cell: row => {
				if (!row.value) return '-';
				const cnpj = String(row.value).replace(/[.\-/]/g, '').toUpperCase();
				if (cnpj.length === 14) {
					return `${cnpj.slice(0, 2)}.${cnpj.slice(2, 5)}.${cnpj.slice(5, 8)}/${cnpj.slice(8, 12)}-${cnpj.slice(12)}`;
				}
				return row.value;
			},
		},
		{
			Header: () => <div className="text-left">Razão social</div>,
			accessor: 'razaoSocial',
			filterMethod: textFilterMethod,
			className: 'text-left',
			Cell: row => <TooltippedCel text={row.value} />,
		},
		{
			Header: 'Status',
			filterable: false,
			accessor: 'principal',
			filterMethod: textFilterMethod,
			className: 'text-left',
			Cell: row => (
				<Row noGutters>
					<Col>
						{row.value ? (
							<Button
								size="sm"
								block
								disabled
								color="success"
								className="falso-disabled btnEmpresaPrincipal"
								alt="Empresa principal">
								Empresa principal
							</Button>
						) : null}
					</Col>
				</Row>
			),
			width: 150,
		},
		{
			Header: 'Tipo de certificado',
			accessor: 'certificado',
			filterMethod: textFilterMethod,
			Cell: row => (
				<div>
					{row.original.usarCertificadoEconet ? (
						<i title="Certificado Econet" className="ecoico ecoico-cert-econet" />
					) : (
						<div>
							{row.original.certificadoNome ? (
								<i title="Certificado A1" className="ecoico ecoico-cert-a1" />
							) : (
								<i title="Certificado da empresa principal" className="ecoico ecoico-cert-filho" />
							)}
						</div>
					)}
				</div>
			),
			className: 'text-center',
			width: 150,
		},
		{
			Header: 'Ação',
			filterable: false,
			sortable: false,
			key: 'action',
			Cell: row => (
				<Row noGutters>
					<Col>
						<Button onClick={() => handleEditar(row)} color="link" alt="Editar" title="Editar">
							<i className="ecoico ecoico-edit" />
							<span>Editar</span>
						</Button>
					</Col>
				</Row>
			),
			className: 'text-center',
			width: 100,
		},
	];

	return (
		<main id="empresas">
			<AlertasContext.Consumer>
				{alertas => {
					showInfoMessage = alertas.info;
					showSuccessMessage = alertas.success;
					showWarningMessage = alertas.warning;
					showErrorMessage = alertas.error;
				}}
			</AlertasContext.Consumer>
			<BlockUiContext.Consumer>
				{blockUi => {
					onLoading = blockUi.handleLoading;
				}}
			</BlockUiContext.Consumer>
			<EmpresasCadastro
				ref={ModalCadastro}
				onClosed={handleReload}
				dataOnUpdate={dataOnUpdate}
				onDataCreated={handleDataCreated}
				onDataUpdated={handleDataUpdated}
			/>
			<Row noGutters id="main-header">
				<Col>
					{
						<Row>
							<Col className="alert alert-primary" style={{ margin: '0px 10px 10px 10px', padding: '10px', fontSize: 'small' }}>
							<strong>Conforme noticia do Portal GNRE, o serviço está indisponível hoje, 16/10/2026, das 08h30 às 18h. O serviço poderá ser restabelecido antes do horário previsto.</strong>
							</Col>
						</Row>
					}

					<Row style={{ display: 'flex', 'justify-content': 'space-between', 'align-items': 'center', 'flex-wrap': 'wrap', padding: '10px', gap: '10px' }}>
						<Col style={{ flex: '0.7 1 0%', 'min-width': '100px' }}>
							<h1 style={{ 'margin-bottom': '0' }}>Empresas</h1>
						</Col>
						{/* <Col style={{ flex: '2 1 0%', 'min-width': '100px' }}>
							<NavLink
								href="https://auditor.econeteditora.com.br/validar-login"
								className="btn btn-secondary"
								target="_blank"
								style={{ padding: '4px 10px 1px 10px', fontSize: 'small' }}>
								Para gerar a <b>GNRE por Apuração</b>, favor auditar o arquivo TXT através do <b>Auditor Fiscal</b>
							</NavLink>
						</Col> */}
					</Row>

					<hr />

					<Row noGutters>
						<Col className="singleHeaderHeight p-0">
							<Container id="buttons" className="p-0">
								<Row>
									<Col xs="auto" className="p-0">
										<Button
											onClick={() => ModalCadastro.current.openModal()}
											size="sm"
											color="primary"
											block>
											<i className="far fa-building" /> Nova empresa
										</Button>
									</Col>
								</Row>
							</Container>
						</Col>
						<Col xs="6" className="singleHeaderHeight mobile-buttons">
							{blShowPesquisaRapida ? (
								<PesquisaRapida
									value={strBusca}
									blShow={blShowPesquisaRapida}
									rawData={rawData}
									onUpdate={onUpdatePesquisaRapida}
								/>
							) : (
								<Container className="p-0">
									<Row>
										<Col />
										<Col xs="auto p-0">
											<Button
												onClick={() => {
													setBlFiltroAtivo(!blFiltroAtivo);
													setShowData(rawData);
													setStrBusca('');
												}}
												color="link">
												<i className="ecoico ecoico-filtro" />
											</Button>
										</Col>
										<Col xs="auto p-0">
											<Button
												onClick={() => {
													setBlShowPesquisaRapida(true);
													setBlFiltroAtivo(false);
												}}
												color="link">
												{strBusca ? (
													<i className="fas fa-search-plus" />
												) : (
													<i className="fas fa-search" />
												)}
											</Button>
										</Col>
									</Row>
								</Container>
							)}
						</Col>
					</Row>
				</Col>
			</Row>
			<Row noGutters>
				<Col>
					<ReactTable
						ref={reactTable}
						data={showData}
						filterable={blFiltroAtivo}
						selectRow={{ mode: 'checkbox'}}
						columns={columns}
						toggleRowsSelected={true}
						showPagination={showData.length > 0}
						showPageSizeOptions={false}
						defaultSorted={[{ id: 'principal', desc: true }, { id: 'razaoSocial', desc: false }]}
						PaginationComponent={Pagination}
						childPaginationValue={childPaginationValue}
						strTableInfo="Empresas"
					/>
				</Col>
			</Row>
		</main>
	);
}

export default withRouter(Empresas);
